<template>
  <div class="profile-review">
    <div v-if="!form">
      <Spinner />
    </div>
    <div v-else class="profile-review__content">
      <div>
        <div>
          <div class="page-title">Creator Review</div>
        </div>
      </div>

      <div class="profile-review__fields">
        <div class="profile-review__topmatter">
          <div class="profile-review__form-row">
            <div class="profile-review__form-row__label">
              <div>Creator:</div>
            </div>
            <div class="profile-review__form-row__value">
              <TableRowAvatar
                :user="form.creator"
                :path="`/p/${form.creator.username || form.creator.id}`"
              />
            </div>
          </div>
          <div class="profile-review__form-row">
            <div class="profile-review__form-row__label">
              <div>Reviewer:</div>
            </div>
            <div class="profile-review__form-row__value">
              <TableRowAvatar
                :user="form.reviewer"
                :path="`/p/${form.reviewer.username || form.reviewer.id}`"
              />
            </div>
          </div>
          <div class="profile-review__form-row">
            <div class="profile-review__form-row__label">
              <div>Rating:</div>
            </div>
            <div class="profile-review__form-row__value">
              <ProfileRating :value="form.rating" />
            </div>
          </div>
          <div class="profile-review__form-row">
            <div class="profile-review__form-row__label">
              <div>Project Code:</div>
            </div>
            <div class="profile-review__form-row__value">
              {{ form.project_code || "None provided" }}
            </div>
          </div>
        </div>
        <div class="profile-review__body">
          <div class="profile-review__form-row">
            <div class="profile-review__form-row__label">Notes:</div>
            <div class="profile-review__form-row__value">{{ form.notes }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableRowAvatar from "@/components/work-assignments/TableRowAvatar.vue";
import ProfileRating from "@/components/profile-review/ProfileRating.vue";

export default {
  head: {
    title: "Creator Review",
    titleTemplate: "%s | iU Community",
  },
  components: { TableRowAvatar, ProfileRating },
  data() {
    return {
      loading: true,
      form: null,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchReview();
    }
  },
  methods: {
    async fetchReview() {
      try {
        const response = await this.$api.ProfileReview.get({
          id: this.$route.params.id,
        });
        this.form = response.data;
      } catch (e) {
        this.$alert("Something went wrong", "error");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.profile-review {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__content {
    width: 600px;
    max-width: 100%;
  }
  &__topmatter {
    display: grid;
    grid-template-columns: 100px auto;
  }
  &__topmatter &__form-row {
    &__label {
      display: flex;
      align-items: center;
    }
  }
  &__form-row {
    padding: 10px 0;
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / span 2;

    &__label {
      color: #56565a;
      font-weight: bold;
      line-height: 1.2;
      padding-right: 20px;
    }
    &__value {
      display: flex;
    }
    &__label,
    &__value {
      @media screen and (max-width: 600px) {
        grid-column: 1 / span 2;
      }
    }
  }
}
</style>
